import React from 'react';
import { Quote } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { getLandingCopy } from '../i18n/landing';

const CaseStudies = () => {
  const { lang } = useLang();
  const cs = getLandingCopy(lang).cs;
  if (!cs) return null;

  return (
    <section className="py-20 md:py-28 bg-ivory" data-testid="case-studies-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14 reveal">
          <span className="inline-flex items-center gap-3 text-[0.7rem] tracking-[0.35em] uppercase text-gold"><span className="w-8 h-px bg-gold" />{cs.k}<span className="w-8 h-px bg-gold" /></span>
          <h2 className="font-serif text-3xl md:text-5xl text-espresso mt-4">{cs.t}</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {cs.items.map((item) => (
            <div key={item.title} className="reveal flex flex-col bg-cream border-t-2 border-gold p-8 hover:-translate-y-1 transition-transform duration-300" data-testid="case-study-card">
              <span className="self-start text-[0.62rem] tracking-[0.2em] uppercase bg-espresso text-gold-light px-3 py-1.5">{item.tag}</span>
              <Quote className="w-6 h-6 text-gold mt-6" />
              <h3 className="font-serif text-2xl text-espresso mt-3 leading-snug">{item.title}</h3>
              <p className="mt-3 text-sm text-mocha leading-relaxed flex-1">{item.text}</p>
              <div className="mt-7 grid grid-cols-3 gap-3 border-t border-gold-soft pt-6">
                {item.stats.map((st) => (
                  <div key={st.l}>
                    <p className="font-serif text-2xl text-gold">{st.v}</p>
                    <p className="mt-1 text-[0.62rem] tracking-wide uppercase text-mocha leading-snug">{st.l}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <p className="mt-8 text-center text-xs text-mocha/70 reveal">{cs.note}</p>
      </div>
    </section>
  );
};

export default CaseStudies;
